import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '../config';
import { prepareHeaders } from '../configuration/tokenHandling/prepareHeaders';
import type { ApiPoi } from './apiTypes';
import { mapPoiDetails } from './mapper/mapPoiDetails';
import type { PoiDetails } from './types';

export const FETCH_POI_TAG = 'FETCH_POI_TAG';

export const poiApi = createApi({
    reducerPath: 'poiApi',
    baseQuery: fetchBaseQuery({
        baseUrl: config.backend.POI_SERVICE,
        prepareHeaders,
    }),
    tagTypes: [FETCH_POI_TAG],
    refetchOnMountOrArgChange: true,
    endpoints: builder => ({
        fetchPoiById: builder.query<PoiDetails, string>({
            query: (poiId: string) => ({
                url: `/pois/${poiId}`,
            }),
            transformResponse: (response: ApiPoi) => mapPoiDetails(response),
            providesTags: [FETCH_POI_TAG],
        }),
    }),
});

export const { useFetchPoiByIdQuery } = poiApi;
